import { memo } from 'react';

function MissedPickupMarker({ backgroundColor, borderColor, size }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path d="M22.78 18V6L12.39 0L2 6V18L12.39 24L22.78 18Z" fill={backgroundColor} />
      <path d="M18.8901 15.5H15.8901V11H11.3901V8H18.8901V15.5Z" fill={borderColor} />
      <path
        d="M11.3901 17.6199L5.33008 11.5599L7.45008 9.43994L11.3901 13.3799L16.3301 8.43994L18.4501 10.5599L11.3901 17.6199Z"
        fill={borderColor}
      />
      <path
        d="M12.39 1.15L21.78 6.57V17.42L12.39 22.84L3 17.42V6.58L12.39 1.15ZM12.39 0L2 6V18L12.39 24L22.78 18V6L12.39 0Z"
        fill={borderColor}
      />
    </svg>
  );
}

export default memo(MissedPickupMarker);
